import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CmsService } from 'src/app/Services/cms.service';

@Component({
  selector: 'app-direitos-passageiros',
  templateUrl: './direitos-passageiros.component.html',
  standalone: false
})
export class DireitosPassageirosComponent implements OnInit{
    // ---CMS---
    documentos_legais_content: string = 'linhas-documentos-legal';
    direitosDeveresPassageiros: any = {};

    constructor(
      private cmsService: CmsService,
      private router: Router,
      private translate: TranslateService,
      private title: Title
    ) {
        this.translate.get('navLinks').pipe().subscribe(trans => {
          let pageTitle =  trans['linhas'] + ' | ' + trans['direitosDeveresPassageiros']
          this.title.setTitle(pageTitle);
        })
      }

  ngOnInit(){
    this.getContent();
  }

  getContent(){
    this.cmsService.getContentList(this.documentos_legais_content, 'pt').subscribe(
      {
        next: data => {
          this.direitosDeveresPassageiros = data['body']['data']['Direitos_Deveres'];
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }
}
